import axios from 'axios';
import qs from 'qs';
import { API_URL } from '../../config';

// Obtener un usuario por su ID
export const getUserById = async (id) => {
  const data = qs.stringify({
    action: 'getUser',
    id: id, // ID del usuario
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: API_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data; // Retorna los datos del usuario
  } catch (error) {
    console.error('Error al obtener el usuario:', error);
    throw error; // Propaga el error para manejarlo desde donde se llama
  }
};

// Obtener todos los usuarios por company_id
export const getAllUsers = async (company_id) => {
  const data = qs.stringify({
    action: 'getAllUsers',
    company_id: company_id,
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: API_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Validar usuario
export const validateUser = async (email, password) => {
  const data = qs.stringify({
    action: 'validateUser',
    identifier: email,
    password: password,
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: API_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Eliminar un usuario por su ID
export const deleteUser = async (id) => {
  const data = qs.stringify({
    action: 'deleteUser',
    id: id, // ID del usuario
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: API_URL, // Usa la URL base definida en tu configuración
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data; // Retorna los datos de la respuesta
  } catch (error) {
    console.error('Error al eliminar el usuario:', error);
    throw error; // Propaga el error para manejarlo en el lugar donde se llama
  }
};


// Obtener historias por ID de empresa
export const getHistoriesByEmpresa = async (id_empresa) => {
  const data = qs.stringify({
    action: 'getHistoriesByEmpresa',
    id_empresa: id_empresa,
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: API_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Obtener empresa por ID
export const getCompanyById = async (id) => {
  const data = qs.stringify({
    action: 'getCompanyById',
    id: id,
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: API_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

// Obtener todas las empresas
export const fetchCompanies = async () => {
  const data = qs.stringify({ action: 'getallcompany' });
  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: API_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    throw new Error('Error al obtener los datos: ' + error.message);
  }
};

// Insertar una nueva empresa
export const insertCompany = async (formData) => {
  const data = new FormData();
  Object.keys(formData).forEach((key) => {
    data.append(key, formData[key]); // Convertir los datos en FormData
  });
  data.append('action', 'insertCompany');

  try {
    const response = await axios.post(API_URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      maxBodyLength: Infinity,
    });
    return response.data; // Retornar los datos de la respuesta
  } catch (error) {
    throw new Error('Error al insertar la empresa: ' + error.message);
  }
};

// Actualizar una empresa existente
export const updateCompany = async (formData) => {
  const data = new FormData();
  Object.keys(formData).forEach((key) => {
    data.append(key, formData[key]);
  });
  data.append('action', 'insertCompany'); // La acción del servicio (mismo que para inserción)

  try {
    const response = await axios.post(API_URL, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      maxBodyLength: Infinity,
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al actualizar la empresa: ' + error.message);
  }
};

// Insertar un nuevo usuario
export const insertUser = async (formData) => {
  const data = qs.stringify({
    action: 'insertUser',
    ...formData,
  });

  try {
    const response = await axios.post(API_URL, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      maxBodyLength: Infinity,
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al insertar el usuario: ' + error.message);
  }
};

// Actualizar un usuario existente
export const updateUser = async (formData) => {
  const data = qs.stringify({
    action: 'updateUser',
    ...formData,
  });

  try {
    const response = await axios.post(API_URL, data, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      maxBodyLength: Infinity,
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al actualizar el usuario: ' + error.message);
  }
};

// Eliminar una empresa por su ID
export const deleteCompany = async (id) => {
  const data = qs.stringify({
    action: 'deleteCompany',
    id: id,
  });

  const config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: API_URL,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    data: data,
  };

  try {
    const response = await axios.request(config);
    return response.data;
  } catch (error) {
    throw new Error('Error al eliminar la empresa: ' + error.message);
  }
};
